export const initialSingleVesselStore = {
  calculatorData: {
    portOperation: [],
    fleetList: [],
    clientQuery: {},
    _id: "",
  },
  selectedVessels: {},
  syncBunker: false,
  isOverride: false,
  estimationEstId: "",
  splitHireArray: [],
  portDistanceResponse: {},
  realPortDistanceResponse: {},
  portDistancePayloadResponse: {},
};
